export const TODO_DATA = [
	{
		id: 1,
		label: "bug",
		color: "danger",
		title: "Mollit sint ad exercitation ullamco elit velit laboris esse voluptate.",
		description:
			"Sint commodo do do incididunt sunt Lorem. Proident aliqua veniam eu ea cillum ad. Incididunt occaecat exercitation consequat magna ex deserunt pariatur sunt eu officia reprehenderit. Velit et adipisicing in sit aute nisi in id enim fugiat magna.",
		completed: false,
		due: {
			date: "21-03-2030",
			time: "02:34",
		},
		files: [
			{
				name: "id.mp3",
				size: "408.kb",
			},
			{
				name: "velit.mp3",
				size: "470.kb",
			},
		],
		priority: "!!!",
	},
	{
		id: 2,
		label: "documetation",
		color: "success",
		title: "Ipsum sint dolore voluptate ea ex dolore laborum aute tempor aliquip ipsum.",
		description:
			"Amet sunt sit voluptate consequat nulla. Enim culpa anim dolore mollit duis ipsum velit labore Lorem fugiat amet. Enim nostrud labore labore mollit occaecat sunt est deserunt sit id. Ad ex cupidatat veniam ullamco cupidatat amet ea laborum irure.",
		completed: false,
		due: {
			date: "27-02-2030",
			time: "13:26",
		},
		files: [
			{
				name: "cillum.mp3",
				size: "510.kb",
			},
		],
		priority: "!!!",
	},
	{
		id: 3,
		label: "feature",
		color: "primary",
		title: "In tempor aliqua dolor nulla magna nulla aliqua eu ipsum duis.",
		description:
			"Anim nisi dolore amet irure dolor. Excepteur ut velit cillum mollit Lorem voluptate ad eu magna sunt occaecat non laboris. Dolore laboris ullamco cillum enim esse ut dolore. Laboris sit ipsum aliquip irure Lorem dolor eiusmod magna id sit adipisicing consequat. Mollit irure dolor do excepteur consectetur occaecat est occaecat adipisicing eiusmod esse veniam. Id sint enim sunt ullamco in velit amet Lorem consectetur aliqua enim.",
		completed: false,
		due: {
			date: "28-03-2030",
			time: "20:42",
		},
		files: [
			{
				name: "sit.jpg",
				size: "222.kb",
			},
			{
				name: "esse.txt",
				size: "431.kb",
			},
			{
				name: "fugiat.gif",
				size: "481.kb",
			},
			{
				name: "nisi.docx",
				size: "360.kb",
			},
		],
		priority: "!!!",
	},
	{
		id: 4,
		label: "bug",
		color: "danger",
		title: "Deserunt nisi dolore duis occaecat velit consectetur exercitation mollit sunt in.",
		description:
			"Exercitation consectetur proident enim cillum qui Lorem tempor. Deserunt officia eiusmod elit anim laboris esse labore. Incididunt in dolore mollit adipisicing reprehenderit Lorem sit anim exercitation incididunt incididunt sit. Enim pariatur exercitation cupidatat irure velit amet pariatur est. Et mollit culpa exercitation culpa anim consequat esse aliquip proident eiusmod laboris. Velit ipsum labore occaecat duis cillum ex magna excepteur.",
		completed: false,
		due: {
			date: "",
			time: "",
		},
		files: [
			{
				name: "enim.mp3",
				size: "267.kb",
			},
			{
				name: "occaecat.mp3",
				size: "55.kb",
			},
		],
		priority: "!",
	},
	{
		id: 5,
		label: "discussion",
		color: "warning",
		title: "Labore fugiat laboris veniam aliqua anim magna enim ad enim anim Lorem commodo pariatur duis.",
		description:
			"Reprehenderit velit excepteur labore nisi dolore laboris anim labore cillum eiusmod. Sit commodo eiusmod nisi ut adipisicing ipsum. Dolore est occaecat mollit fugiat ipsum id excepteur reprehenderit mollit reprehenderit eiusmod. Elit et incididunt occaecat minim ipsum pariatur. Minim ad velit esse cupidatat minim deserunt dolor laboris aliquip.",
		completed: false,
		due: {
			date: "",
			time: "",
		},
		files: [],
		priority: "!!",
	},
	{
		id: 6,
		label: "feature",
		color: "primary",
		label: "verison 2.0",
		color: "success",
		title: "Voluptate in est dolor voluptate fugiat elit ex.",
		description:
			"Nisi nostrud non dolore ullamco amet cillum exercitation ipsum irure do cupidatat. Ut exercitation magna ipsum ad nulla deserunt ea irure. Voluptate dolor esse consectetur incididunt labore qui amet. Irure reprehenderit quis laborum id velit esse velit irure aliquip nulla sint anim.",
		completed: false,
		due: {
			date: "26-03-2030",
			time: "13:18",
		},
		files: [],
		priority: "!",
	},
	{
		id: 7,
		label: "feature",
		color: "primary",
		title: "Est commodo veniam irure eu pariatur nulla pariatur.",
		description:
			"Occaecat velit eiusmod labore eu consequat sint cillum sunt incididunt reprehenderit aliqua cillum consequat. Aute id pariatur ea proident minim est amet ad exercitation eu dolor. Do esse sunt cillum occaecat quis anim. Sint in pariatur ut aute exercitation quis sit duis esse est sint elit. Id dolore ullamco consequat eu ut elit. Laboris irure velit commodo id dolor incididunt laborum commodo labore aliquip sint incididunt. Occaecat amet consectetur mollit elit cillum id quis consequat cillum qui culpa eiusmod.",
		completed: false,
		due: {
			date: "31-03-2030",
			time: "10:14",
		},
		files: [],
		priority: "!!!",
	},
	{
		id: 8,
		label: "documentation",
		color: "success",
		title: "Tempor aliquip eu in consequat esse ex.",
		description:
			"Nisi laboris est adipisicing incididunt tempor eiusmod non laborum deserunt nulla. Magna minim aute minim fugiat proident nulla. Incididunt veniam ex qui officia do et voluptate ea eu fugiat ipsum cupidatat aute pariatur. Tempor quis nulla consectetur officia sit commodo in qui eu anim incididunt enim minim officia. Id reprehenderit veniam fugiat nulla elit consequat deserunt ut eiusmod qui minim eu.",
		completed: false,
		due: {
			date: "07-03-2030",
			time: "06:24",
		},
		files: [],
		priority: "!!!",
	},
	{
		id: 9,
		label: "design",
		color: "info",
		title: "Duis nostrud ea aliqua proident adipisicing cupidatat.",
		description:
			"Velit sint reprehenderit aliqua occaecat nisi laboris deserunt. Qui ea dolor consectetur ex amet pariatur pariatur cupidatat enim amet minim cupidatat reprehenderit sunt. Cupidatat fugiat occaecat ullamco occaecat nulla commodo enim fugiat tempor non qui laborum. Occaecat id duis velit nisi non officia culpa. Consequat duis incididunt laboris dolore ipsum et consectetur exercitation nostrud occaecat id ad nisi. Aliqua irure officia sint occaecat consectetur non dolore anim fugiat fugiat pariatur ex. Amet minim consectetur esse aute.",
		completed: false,
		due: {
			date: "",
			time: "",
		},
		files: [
			{
				name: "Lorem.mp3",
				size: "533.kb",
			},
			{
				name: "mollit.txt",
				size: "857.kb",
			},
			{
				name: "velit.pdf",
				size: "274.kb",
			},
			{
				name: "commodo.jpg",
				size: "513.kb",
			},
			{
				name: "pariatur.docx",
				size: "162.kb",
			},
		],
		priority: "!!",
	},
	{
		id: 10,
		label: "design",
		color: "info",
		title: "Incididunt incididunt incididunt dolore commodo laborum ut ea pariatur ullamco.",
		description:
			"Ad non in laboris esse cillum anim dolor adipisicing anim labore deserunt anim ipsum. Consectetur adipisicing ex ullamco sint cupidatat pariatur dolore sunt culpa consequat magna minim id. Deserunt cillum occaecat irure anim.",
		completed: false,
		due: {
			date: "23-03-2030",
			time: "01:50",
		},
		files: [
			{
				name: "consequat.gif",
				size: "790.kb",
			},
		],
		priority: "!!",
	},
	{
		id: 11,
		label: "bug",
		color: "danger",
		title: "Eiusmod nulla aliquip laborum non aliquip nulla minim.",
		description:
			"Excepteur irure irure Lorem do cillum in irure. Officia enim qui qui incididunt id eu id aute eiusmod commodo non exercitation ipsum officia. Elit deserunt non est et ea anim sint ullamco ea. Qui enim tempor exercitation aute ipsum. Culpa est occaecat ipsum et deserunt veniam qui. Occaecat in sit eu qui ullamco nisi consequat ex voluptate duis.",
		completed: false,
		due: {
			date: "18-03-2030",
			time: "02:36",
		},
		files: [
			{
				name: "do.gif",
				size: "868.kb",
			},
			{
				name: "ipsum.csv",
				size: "539.kb",
			},
			{
				name: "irure.txt",
				size: "472.kb",
			},
			{
				name: "officia.jpg",
				size: "559.kb",
			},
		],
		priority: "!",
	},
	{
		id: 12,
		label: "priority:severe",
		color: "danger",
		title: "Irure cupidatat consequat anim aliquip esse consequat anim aute non occaecat et cillum.",
		description:
			"Excepteur exercitation deserunt enim ullamco ut commodo tempor elit eu sunt in ut magna. Velit dolor tempor aliquip consectetur irure adipisicing. Dolor eiusmod ex magna in et. Veniam minim deserunt Lorem esse pariatur Lorem. Labore laborum nostrud voluptate exercitation.",
		completed: false,
		due: {
			date: "",
			time: "",
		},
		files: [],
		priority: "!",
	},
	{
		id: 13,
		label: "security",
		color: "warning",
		title: "Ipsum ad dolore in laborum occaecat tempor et commodo sunt occaecat proident exercitation consequat elit.",
		description:
			"Officia irure do velit Lorem enim enim. In ad dolor laboris esse cupidatat aliqua sint reprehenderit. Elit non ad consectetur ut voluptate ad cupidatat. Adipisicing voluptate labore officia ullamco enim in qui aute.",
		completed: false,
		due: {
			date: "",
			time: "",
		},
		files: [],
		priority: "!",
	},
	{
		id: 14,
		label: "bug",
		color: "danger",
		title: "Eiusmod incididunt do ea aute ad nisi sunt consequat.",
		description:
			"Ullamco magna est sit reprehenderit velit ut dolore proident aliquip dolore cillum. Commodo incididunt proident veniam proident Lorem. Sit adipisicing voluptate non id sit. Et ad duis cillum in elit sit officia duis. Incididunt incididunt nisi in aliqua sit sint sit duis consectetur.",
		completed: false,
		due: {
			date: "",
			time: "",
		},
		files: [],
		priority: "!",
	},
	{
		id: 15,
		label: "feature",
		color: "primary",
		title: "Ullamco excepteur amet consequat eiusmod.",
		description:
			"Ipsum aute ut laborum reprehenderit non duis. Esse aute aute enim nostrud deserunt magna aliquip incididunt excepteur occaecat eiusmod eiusmod. Elit ad quis nostrud pariatur non adipisicing. Incididunt tempor elit ut laboris anim nisi exercitation. Consequat voluptate et aliqua proident. Cillum ad exercitation laboris esse nisi anim fugiat sint ipsum est quis voluptate.",
		completed: false,
		due: {
			date: "31-03-2030",
			time: "08:27",
		},
		files: [
			{
				name: "labore.docx",
				size: "445.kb",
			},
			{
				name: "nisi.docx",
				size: "518.kb",
			},
			{
				name: "voluptate.txt",
				size: "194.kb",
			},
		],
		priority: "!!!",
	},
	{
		id: 16,
		label: "obsolete",
		color: "lime",
		title: "Officia est est eu non ea esse nisi reprehenderit ut.",
		description:
			"Officia incididunt nulla ut reprehenderit consequat. Et deserunt id enim quis irure consequat quis enim. Esse in enim Lorem excepteur ad amet fugiat labore sunt culpa fugiat adipisicing do.",
		completed: false,
		due: {
			date: "11-03-2030",
			time: "01:41",
		},
		files: [
			{
				name: "est.csv",
				size: "535.kb",
			},
			{
				name: "dolore.jpg",
				size: "947.kb",
			},
			{
				name: "non.pdf",
				size: "104.kb",
			},
			{
				name: "consequat.txt",
				size: "754.kb",
			},
		],
		priority: "!!!",
	},
	{
		id: 17,
		label: "obsolete",
		color: "lime",
		title: "Officia sint nisi dolor eiusmod ex dolore fugiat nisi laborum sint.",
		description:
			"Nisi adipisicing cupidatat nisi adipisicing consectetur voluptate duis eu est irure sint cillum. Dolor minim ut minim nisi in fugiat duis reprehenderit qui magna. Nisi sint velit enim officia aliqua. Deserunt irure ullamco non nisi ullamco fugiat aute officia minim proident ad nisi anim esse. Nisi ullamco aliquip commodo mollit. Elit nostrud dolore qui nisi id voluptate Lorem duis magna nisi Lorem consectetur adipisicing commodo.",
		completed: false,
		due: {
			date: "19-03-2030",
			time: "16:55",
		},
		files: [
			{
				name: "velit.docx",
				size: "448.kb",
			},
		],
		priority: "!!!",
	},
	{
		id: 18,
		label: "obsolete",
		color: "lime",
		title: "Velit veniam incididunt aute irure enim enim exercitation eiusmod mollit amet.",
		description:
			"Est pariatur dolore occaecat Lorem laboris irure aliqua qui dolore velit aliqua veniam. Exercitation cillum ad qui irure aliqua enim ea veniam laboris voluptate cillum tempor Lorem. Velit est amet proident eu reprehenderit. Laborum magna minim officia est aute ullamco adipisicing proident proident aliqua sunt. Id aliqua ex et sunt.",
		completed: false,
		due: {
			date: "05-03-2030",
			time: "07:51",
		},
		files: [
			{
				name: "eiusmod.txt",
				size: "908.kb",
			},
			{
				name: "aliquip.csv",
				size: "557.kb",
			},
			{
				name: "ad.gif",
				size: "16.kb",
			},
			{
				name: "dolore.txt",
				size: "851.kb",
			},
		],
		priority: "!!",
	},
	{
		id: 19,
		label: "version 2.0",
		color: "primary",
		title: "Cupidatat aute exercitation nisi culpa do nisi qui esse irure elit.",
		description:
			"Et ipsum officia sunt Lorem do non quis nostrud proident nostrud. Irure commodo veniam irure anim culpa nostrud cupidatat. Ullamco amet laborum commodo aliqua eu qui amet cupidatat. Minim excepteur esse anim aute proident reprehenderit qui exercitation magna. Aliquip id ea commodo culpa non velit ut mollit enim qui excepteur enim voluptate. Fugiat occaecat ex minim occaecat sint ad.",
		completed: false,
		due: {
			date: "11-03-2030",
			time: "03:45",
		},
		files: [
			{
				name: "reprehenderit.docx",
				size: "243.kb",
			},
			{
				name: "laboris.mp3",
				size: "763.kb",
			},
			{
				name: "esse.csv",
				size: "91.kb",
			},
			{
				name: "magna.jpg",
				size: "430.kb",
			},
			{
				name: "voluptate.docx",
				size: "741.kb",
			},
		],
		priority: "!!",
	},
	{
		id: 20,
		label: "documentation",
		color: "success",
		title: "Culpa qui ex do cillum irure quis pariatur nulla occaecat.",
		description:
			"Cillum in aute aute duis ut nulla veniam culpa magna mollit nisi eu quis mollit. Sint est cupidatat aliqua dolore. Ullamco nulla velit nostrud sit duis nisi velit officia. Sit cillum elit pariatur irure labore.",
		completed: false,
		due: {
			date: "",
			time: "",
		},
		files: [],
		priority: "!",
	},
	{
		id: 21,
		label: "bug",
		color: "danger",
		title: "Exercitation pariatur fugiat sit aute in laborum aliquip ea aute adipisicing irure amet.",
		description:
			"Elit non fugiat eu dolor incididunt in dolore cupidatat fugiat. Laborum veniam veniam sunt ex. Lorem esse laborum cillum cupidatat reprehenderit qui commodo veniam id culpa commodo culpa. Sunt ut elit incididunt voluptate voluptate incididunt irure adipisicing ullamco fugiat irure cupidatat. Do sunt incididunt veniam sint pariatur ad enim. Quis duis non reprehenderit commodo ad veniam nisi reprehenderit non. Reprehenderit reprehenderit et minim irure exercitation minim ad sint anim deserunt aliqua enim culpa Lorem.",
		completed: false,
		due: {
			date: "26-02-2030",
			time: "22:17",
		},
		files: [
			{
				name: "magna.docx",
				size: "348.kb",
			},
			{
				name: "officia.docx",
				size: "918.kb",
			},
			{
				name: "ea.csv",
				size: "339.kb",
			},
			{
				name: "commodo.jpg",
				size: "873.kb",
			},
		],
		priority: "!!",
	},
	{
		id: 22,
		label: "design",
		color: "info",
		title: "Reprehenderit sint ipsum aliquip commodo incididunt quis pariatur.",
		description:
			"Culpa est et velit in consectetur enim eu enim ipsum ullamco. Consequat adipisicing non laboris quis excepteur laboris exercitation amet qui tempor id enim aute in. Amet ad occaecat tempor dolor sit ut voluptate. Elit dolore anim excepteur in. In nostrud exercitation labore labore voluptate nisi. Cillum dolore deserunt occaecat commodo fugiat excepteur aliqua deserunt tempor. Non sit do nisi cillum qui exercitation proident ipsum amet.",
		completed: false,
		due: {
			date: "17-03-2030",
			time: "07:39",
		},
		files: [
			{
				name: "Lorem.docx",
				size: "140.kb",
			},
		],
		priority: "!!!",
	},
	{
		id: 23,
		label: "design",
		color: "info",
		title: "Lorem officia eu sit voluptate cillum irure sunt eiusmod non.",
		description:
			"Reprehenderit pariatur ea aute incididunt est esse qui sint ex esse laborum proident. Labore aliquip aliquip magna qui excepteur consequat amet. Eiusmod dolor sit culpa dolore eiusmod pariatur enim voluptate exercitation deserunt cillum exercitation sint. Non nisi fugiat elit ex voluptate do dolore quis reprehenderit exercitation exercitation aliquip. Aliquip eiusmod quis culpa esse. Voluptate in ex commodo anim magna amet tempor esse.",
		completed: false,
		due: {
			date: "26-02-2030",
			time: "15:11",
		},
		files: [
			{
				name: "ad.csv",
				size: "182.kb",
			},
			{
				name: "ex.gif",
				size: "120.kb",
			},
			{
				name: "quis.txt",
				size: "980.kb",
			},
			{
				name: "aute.txt",
				size: "819.kb",
			},
		],
		priority: "!!!",
	},
	{
		id: 24,
		label: "priority:severe",
		color: "danger",
		title: "Est laborum consequat commodo non ex irure et anim qui.",
		description:
			"Dolor adipisicing quis eu irure ea veniam nulla ad. Aliquip aliquip commodo irure non cillum. Quis ea cillum qui nisi excepteur commodo commodo quis tempor. Anim laborum eu nostrud minim nulla fugiat proident velit pariatur excepteur fugiat.",
		completed: false,
		due: {
			date: "",
			time: "",
		},
		files: [],
		priority: "!",
	},
	{
		id: 25,
		label: "priority:severe",
		color: "danger",
		title: "Sit cillum dolor tempor enim.",
		description:
			"Eu nisi consectetur pariatur reprehenderit dolor aute excepteur consequat id ea proident minim labore amet. Nulla quis amet occaecat duis veniam ipsum. Aliqua deserunt irure quis nisi ullamco. Nulla laborum tempor do laborum consequat nulla ea anim. Ullamco ex consequat sit sit minim id exercitation sint excepteur. Consequat occaecat eu voluptate mollit nulla occaecat officia esse ex labore occaecat enim aliquip cupidatat. Anim in nostrud quis reprehenderit nostrud nisi ex.",
		completed: false,
		due: {
			date: "26-03-2030",
			time: "17:36",
		},
		files: [
			{
				name: "quis.gif",
				size: "136.kb",
			},
			{
				name: "magna.csv",
				size: "827.kb",
			},
		],
		priority: "!",
	},
	{
		id: 26,
		label: "blocked",
		color: "lime",
		title: "Tempor irure eu Lorem esse proident qui tempor laboris consectetur ipsum Lorem elit incididunt dolor.",
		description:
			"Et laboris do cillum consequat sunt nostrud ut officia. Eu enim mollit do esse do aute dolor cupidatat. Reprehenderit incididunt do elit dolore. Laboris adipisicing quis culpa anim dolor consectetur fugiat nulla nulla.",
		completed: false,
		due: {
			date: "06-03-2030",
			time: "06:37",
		},
		files: [],
		priority: "!",
	},
	{
		id: 27,
		label: "bug",
		color: "danger",
		title: "Esse sunt ex cillum excepteur in id laborum dolor est.",
		description:
			"Consequat Lorem ex ex nisi in esse sint reprehenderit Lorem et esse amet ullamco. Labore dolore irure nulla et qui non eiusmod Lorem labore esse. Mollit id anim esse sunt id esse. Cillum sit eu voluptate adipisicing eiusmod aute ipsum aliquip occaecat ipsum elit nulla occaecat. Qui tempor aliqua tempor ea ullamco voluptate dolore eu sit pariatur officia adipisicing aliquip elit. Consequat sit aute mollit commodo est pariatur aliqua consequat labore minim ex ipsum.",
		completed: false,
		due: {
			date: "11-03-2030",
			time: "04:05",
		},
		files: [
			{
				name: "commodo.pdf",
				size: "977.kb",
			},
			{
				name: "cillum.csv",
				size: "769.kb",
			},
			{
				name: "mollit.docx",
				size: "72.kb",
			},
			{
				name: "fugiat.docx",
				size: "439.kb",
			},
			{
				name: "exercitation.txt",
				size: "423.kb",
			},
		],
		priority: "!",
	},
	{
		id: 28,
		label: "bug",
		color: "danger",
		title: "Velit eiusmod esse tempor reprehenderit ut ea aute elit reprehenderit in ex voluptate.",
		description:
			"Velit aliquip deserunt consequat laborum dolor cupidatat. Sit pariatur anim culpa cillum tempor consectetur. Ullamco irure nostrud laboris quis esse consectetur ipsum officia. Dolore laborum dolore veniam nostrud occaecat occaecat eu aute ipsum in exercitation. Laboris ea excepteur aute ullamco sint qui ad aliquip qui ad ipsum. Non nulla amet reprehenderit minim id non excepteur.",
		completed: false,
		due: {
			date: "05-03-2030",
			time: "00:07",
		},
		files: [],
		priority: "!",
	},
	{
		id: 29,
		label: "bug",
		color: "danger",
		title: "Do aute tempor esse eiusmod ut sit dolor laboris labore proident nostrud.",
		description:
			"Laborum exercitation ad nisi tempor anim qui irure officia mollit exercitation sunt dolore ullamco ex. Anim voluptate reprehenderit ad non officia minim enim et ipsum anim aute labore duis. Mollit magna consequat aute in proident dolore. Enim laboris magna consectetur eiusmod labore consequat deserunt pariatur esse ad voluptate anim laborum. Elit veniam consectetur elit fugiat eiusmod ipsum sit sint deserunt aute. Non ea do id velit mollit enim.",
		completed: false,
		due: {
			date: "24-03-2030",
			time: "11:50",
		},
		files: [],
		priority: "!!!",
	},
	{
		id: 30,
		label: "feature",
		color: "primary",
		title: "Proident voluptate qui proident nostrud quis duis eiusmod fugiat.",
		description:
			"Excepteur voluptate ut nostrud est. Reprehenderit aute veniam nisi cillum laboris aliqua deserunt. Duis irure ea irure ut cillum. Mollit est ullamco fugiat reprehenderit et. Sint duis ex proident adipisicing consectetur exercitation irure.",
		completed: false,
		due: {
			date: "16-03-2030",
			time: "16:57",
		},
		files: [
			{
				name: "laboris.mp3",
				size: "176.kb",
			},
			{
				name: "ullamco.gif",
				size: "775.kb",
			},
			{
				name: "velit.txt",
				size: "255.kb",
			},
			{
				name: "laborum.pdf",
				size: "344.kb",
			},
		],
		priority: "!!",
	},
];

export const DETAILS = [
	{
		task: "Cillum laboris ipsum tempor eu reprehenderit fugiat ex qui quis sunt irure exercitation officia.",
		completed: false,
	},
	{
		task: "Dolore pariatur ullamco in qui nulla voluptate sunt ut sunt.",
		completed: false,
	},
	{
		task: "Culpa do id anim amet enim enim. Reprehenderit et consequat sunt velit sit minim eiusmod amet tempor eu incididunt cupidatat. Fugiat consectetur tempor pariatur eiusmod do commodo Lorem veniam id ipsum. Lorem eiusmod Lorem tempor est mollit exercitation nulla exercitation velit nisi reprehenderit.",
		completed: false,
	},
	{
		task: "Fugiat ad non aliquip sunt sint laboris. Aute veniam cillum tempor et duis amet.",
		completed: false,
	},
	{
		task: "Deserunt duis non incididunt esse.",
		completed: false,
	},
];
